export default __webpack_public_path__ + "static/media/sofia_xl.e645b606.jpg";